import { render, staticRenderFns } from "./TournamentsManagement.vue?vue&type=template&id=b0de089e&scoped=true"
import script from "./TournamentsManagement.vue?vue&type=script&lang=js"
export * from "./TournamentsManagement.vue?vue&type=script&lang=js"
import style0 from "./TournamentsManagement.vue?vue&type=style&index=0&id=b0de089e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0de089e",
  null
  
)

export default component.exports